module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phoneInvalid":"Invalid phone number, the right format is: +1##########"},"es":{"phoneInvalid":"Número de teléfono no válido, el formato correcto es: +1##########"}}')
  delete Component.options._Ctor
}
